import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

export interface NavItem {
  text: string;
  icon: OverridableComponent<SvgIconTypeMap> & { muiName: string };
  path: string;
  badge?: {
    content: string | number;
    color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  };
  ariaLabel?: string;
  // If true, only show for PRO plan
  proOnly?: boolean;
}

const navigationItems: NavItem[] = [
  { 
    text: 'Dashboard', 
    icon: DashboardIcon, 
    path: '/dashboard',
    ariaLabel: 'Ir al Dashboard',
    proOnly: true  // Only show for PRO plan
  },
  {
    text: 'Comprobantes',
    icon: ReceiptLongIcon,
    path: '/facturas',
    ariaLabel: 'Ir a Comprobantes'
  },
  // { 
  //   text: 'Análisis', 
  //   icon: BarChartIcon, 
  //   path: '/analisis',
  //   ariaLabel: 'Ir a Análisis'
  // },
  // { 
  //   text: 'Finanzas', 
  //   icon: AccountBalanceIcon, 
  //   path: '/finanzas',
  //   badge: {
  //     content: 'Nuevo',
  //     color: 'success'
  //   },
  //   ariaLabel: 'Ir a Finanzas'
  // },
  { 
    text: 'Configuración', 
    icon: SettingsIcon, 
    path: '/configuracion',
    ariaLabel: 'Ir a Configuración'
  },
  // {
  //   text: 'Perfil',
  //   icon: PersonIcon,
  //   path: '/profile',
  //   ariaLabel: 'Ir a Perfil'
  // }
];

export default navigationItems;
